var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "controls-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "control",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.$emit("zoom-in")
          }
        }
      },
      [_c("i", { staticClass: "fas fa-search-plus fa-lg" })]
    ),
    _vm._v(" "),
    _c("hr", { staticClass: "spacer" }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "control",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.$emit("zoom-out")
          }
        }
      },
      [_c("i", { staticClass: "fas fa-search-minus fa-lg" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }